import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const BookmarkFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5.00129 18.9409C5.00077 19.7756 5.96275 20.2436 6.61911 19.7278L12 15.5L17.3822 19.7289C18.0383 20.2444 19 19.777 19 18.9425V5C19 3.9 18.1 3 17 3Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
